import { render, staticRenderFns } from "./Sanmak.vue?vue&type=template&id=56468f1c&scoped=true"
import script from "./Sanmak.vue?vue&type=script&lang=js"
export * from "./Sanmak.vue?vue&type=script&lang=js"
import style0 from "./Sanmak.vue?vue&type=style&index=0&id=56468f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56468f1c",
  null
  
)

export default component.exports